import {SupportedLocales} from '@gl/types/locale.js';

export const journeysLanguage = {
  [SupportedLocales.EN]: {
    actions: {
      cancel: 'Cancel',
      apply: 'Confirm',
    },
    hardResetModal: {
      title: 'Hard Reset the Journey',
      description:
        'This will reset all users to the entry node, and removes any records of previous executions (Note: Exports cannot be undone)',
    },
    manualModeModal: {
      title: 'Manual Mode Run Confirmation',
      description: (manualRunType: string) =>
        `Are you sure you want to run ${manualRunType}?`,
      runUntilThisNode: 'until this node',
      runOnlyThisNode: 'only this node',
      runFromThisNode: 'from this node',
    },
  },
  [SupportedLocales.ES]: {
    actions: {
      cancel: 'Cancelar',
      apply: 'Confirmar',
    },
    hardResetModal: {
      title: 'Reiniciar la Jornada',
      description:
        'Esto reiniciará a todos los usuarios al nodo de entrada y eliminará cualquier registro de ejecuciones anteriores (Nota: Las exportaciones no se pueden deshacer)',
    },
    manualModeModal: {
      title: 'Confirmación de Ejecución Manual',
      description: (manualRunType: string) =>
        `¿Estás seguro de que quieres ejecutar ${manualRunType}?`,
      runUntilThisNode: 'hasta este nodo',
      runOnlyThisNode: 'solo este nodo',
      runFromThisNode: 'desde este nodo',
      actions: {
        cancel: 'Cancelar',
        apply: 'Confirmar',
      },
    },
  },
};
